exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".AddEligibilityConfirmation_Caution_1E9BL {\n    color: red;\n    fontSize:16px;\n    paddingBottom: 5px;\n}\n\n.AddEligibilityConfirmation_Section_2e6eG {\n    width: 50%;\n}\n\n.AddEligibilityConfirmation_SectionTitle_3iIC6 {\n    padding-bottom: 5px;\n    font-weight: bolder;\n    color: #660000;\n}\n\n.AddEligibilityConfirmation_ButtonDiv_31BR_ {\n    display: flex;\n    justify-content: center;\n}\n\n.AddEligibilityConfirmation_EligSection_1fw8c {\n    display: flex;\n    flexFlow: row;\n    width: 100%\n}", ""]);

// Exports
exports.locals = {
	"Caution": "AddEligibilityConfirmation_Caution_1E9BL",
	"Section": "AddEligibilityConfirmation_Section_2e6eG",
	"SectionTitle": "AddEligibilityConfirmation_SectionTitle_3iIC6",
	"ButtonDiv": "AddEligibilityConfirmation_ButtonDiv_31BR_",
	"EligSection": "AddEligibilityConfirmation_EligSection_1fw8c"
};